/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Designer_HintInputs */

const cs_pipelines_designer_hint = /** @type {(inputs: Pipelines_Designer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Více řádků“ rozloží fáze na obrazovku. Šipky ← → na kartě změní pořadí, Fit srovná pohled.`)
};

const en_pipelines_designer_hint = /** @type {(inputs: Pipelines_Designer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Multiple rows” fits stages on screen. ← → on a card reorders; Fit resets the view.`)
};

/**
* | output |
* | --- |
* | "“Multiple rows” fits stages on screen. ← → on a card reorders; Fit resets the view." |
*
* @param {Pipelines_Designer_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_designer_hint = /** @type {((inputs?: Pipelines_Designer_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Designer_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_designer_hint(inputs)
	return cs_pipelines_designer_hint(inputs)
});